import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MassiveAdminPaymentComponent } from './massive-admin-payment.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { CtControlModule, CtButtonModule, CtFormModule } from '@ctsolution/ct-framework';
import { TranslateModule } from '@ngx-translate/core';
import { TableModule } from 'primeng/table';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    CtControlModule,
    FormsModule,
    ReactiveFormsModule,
    CtButtonModule,
    MatDialogModule,
    CtFormModule,
    TableModule
  ],
  declarations: [MassiveAdminPaymentComponent],
  exports: [MassiveAdminPaymentComponent]
})
export class MassiveAdminPaymentModule { }
